import { render, staticRenderFns } from "./shop-search.vue?vue&type=template&id=4476f6fa&"
import script from "./shop-search.vue?vue&type=script&lang=js&"
export * from "./shop-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports